import React from "react";
import Aya from "./components/Aya";
import { TransformContextProvider } from "./store/transform-context";

function App() {
  return (
    <TransformContextProvider>
      <Aya />
    </TransformContextProvider>
  );
}

export default App;
